import { Icon } from '@iconify/react';

export const skills = [
    {
    id: 1,
    icon: <Icon icon="skill-icons:html" width="50" />,
    skill: "HTML5"
    },
    {
    id: 2,
    icon: <Icon icon="skill-icons:css" width="50"/>,
    skill: "CSS3"
    },
    {   
    id: 3,
    icon: <Icon icon="skill-icons:mysql-dark" width="50"/>,
    skill: "SQL"
    },
    {
    id: 4,
    icon: <Icon icon="skill-icons:javascript" width="50"/>,
    skill: "JavaScript"
    },
    {
    id: 5,
    icon: <Icon icon="skill-icons:git" width="50"/>,
    skill: "Git"
    },
    {
    id: 6,
    icon: <Icon icon="skill-icons:github-dark" width="50"/>,
    skill: "GitHub"
    },
    {
    id: 7,
    icon: <Icon icon="skill-icons:react-dark" width="50"/>,
    skill: "ReactJS"
    },
    {   
    id: 8,
    icon: <Icon icon="skill-icons:tailwindcss-dark" width="50"/>,
    skill: "TailWind"
    },
    {   
    id: 9,
    icon: <Icon icon="skill-icons:redux" width="50"/>,
    skill: "Redux"
    },
    {   
    id: 10,
    icon: <Icon icon="skill-icons:java-dark" width="50"/>,
    skill: "Java"
    },
    {   
    id: 11,
    icon: <Icon icon="skill-icons:spring-dark" width="50"/>,
    skill: "Spring"
    }

]